'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/ui/components';
import { cn } from '@repo/ui/lib';
import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';
import { useState } from 'react';
function Input(t0) {
  const $ = _c(28);
  let EndIcon;
  let className;
  let props;
  let startIcon;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      EndIcon,
      startIcon,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = EndIcon;
    $[2] = className;
    $[3] = props;
    $[4] = startIcon;
    $[5] = type;
  } else {
    EndIcon = $[1];
    className = $[2];
    props = $[3];
    startIcon = $[4];
    type = $[5];
  }
  const [showPassword, setShowPassword] = useState(false);
  let t1;
  if ($[6] !== showPassword) {
    t1 = () => {
      setShowPassword(!showPassword);
    };
    $[6] = showPassword;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const togglePasswordVisibility = t1;
  const t2 = startIcon && "ps-8";
  let t3;
  if ($[8] !== className || $[9] !== t2) {
    t3 = cn("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", t2, className);
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = showPassword ? "text" : type;
  let t5;
  if ($[11] !== props || $[12] !== t3 || $[13] !== t4) {
    t5 = <input className={t3} data-slot="input" type={t4} {...props} />;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== showPassword || $[16] !== togglePasswordVisibility || $[17] !== type) {
    t6 = type === "password" && <Button className="absolute top-0 right-0" onClick={togglePasswordVisibility} size="icon" type="button" variant="ghost">{showPassword ? <EyeOff /> : <Eye />}</Button>;
    $[15] = showPassword;
    $[16] = togglePasswordVisibility;
    $[17] = type;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== startIcon) {
    t7 = startIcon && <div className="text-muted-foreground/80 pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 peer-disabled:opacity-50">{startIcon}</div>;
    $[19] = startIcon;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== EndIcon) {
    t8 = EndIcon && <div className="text-muted-foreground/80 pointer-events-none absolute inset-y-0 end-0 flex items-center justify-center pe-3 peer-disabled:opacity-50"><EndIcon size={16} /></div>;
    $[21] = EndIcon;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <div className="relative w-full">{t5}{t6}{t7}{t8}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
export { Input };